import { CommonModule, LocationStrategy } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { FooterComponent } from 'app/components/footer/footer.component';
import { HeaderComponent } from 'app/components/header/header.component';
import { Router, RouterModule } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { InfoDialogComponent } from './info-dialog/info-dialog.component';

@Component({
    selector: 'app-status-info',
    templateUrl: './status-info.component.html',
    styleUrls: ['./status-info.component.scss'],
    standalone: true,
    imports: [
        FormsModule,
        CommonModule,
        MatIconModule,
        TranslateModule,
        ReactiveFormsModule,
        HeaderComponent,
        FooterComponent,
        RouterModule,
    ],
    styles: [
        `
            :host {
                width: 100%;
            }
        `,
    ],
})
export class StatusInfoComponent {
    submissionDetails: any = {};
    ticketId: any;
    prodCode: any;
    productName: any;
    productDetails = [];
    ticketDetails = [];
    fASelected: boolean = false;

    constructor(
        private router: Router,
        public dialog: MatDialog,
        private location: LocationStrategy
    ) {
        this.fASelected =
            this.router.getCurrentNavigation().extras.state?.fASelected;
        this.submissionDetails =
            this.router.getCurrentNavigation().extras.state?.submissionDetails;
        this.prodCode =
            this.router.getCurrentNavigation().extras.state?.prodCode;
    }

    ngOnInit() {
        this.onBrowserBackClick();
    }

    onBrowserBackClick() {
        history.pushState(null, null, window.location.href);
        this.location.onPopState(() => {
            history.pushState(null, null, window.location.href);
        });
    }

    openDialog() {
        this.dialog.open(InfoDialogComponent, {
            position: {
                top: '5%',
            },
            width: '90%',
            backdropClass: 'status-info-dialog-background',
            hasBackdrop: true,
            panelClass: 'status-info-custom-dialog',
        });
    }

    goToDashboard() {
        this.router.navigate(['/dashboard']);
    }

    goToHome() {
        this.router.navigate(['/home']);
    }
}
